import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { PaymentTermActions } from './payment-term.actions';
import { AlertService } from '../alert/alert.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { PaymentTermService } from '../../services/payment-term.service';
import { PaymentTerm } from '../../models/payment-term.model';
import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';

export class PaymentTermStateModel {
  public paymentTerms: PaymentTerm[];
  public error: string;
}

const defaults = {
  paymentTerms: [],
  error: '',
};

@State<PaymentTermStateModel>({
  name: 'paymentTerm',
  defaults
})
@Injectable()
export class PaymentTermState {

  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private paymentTermService: PaymentTermService
  ) { }

  @Action(PaymentTermActions.GetPaymentTerms)
  getPaymentTerms(ctx: StateContext<PaymentTermStateModel>, {  }: PaymentTermActions.GetPaymentTerms) {
    return this.paymentTermService.getPaymentTerms().subscribe({
      next: (paymentTerm: PaymentTerm[]) => {
        ctx.dispatch(new PaymentTermActions.GetPaymentTermsSuccess(paymentTerm));
      },
      error: (error) => {
        ctx.dispatch(new PaymentTermActions.GetPaymentTermsFail(error));
      }
    });
  }

  @Action(PaymentTermActions.GetPaymentTermsSuccess)
    getPaymentTermsSuccess(ctx: StateContext<PaymentTermStateModel>,
      { paymentTerms }: PaymentTermActions.GetPaymentTermsSuccess
    ) {
      ctx.patchState({
        paymentTerms: paymentTerms
      });
    }

  @Action(PaymentTermActions.GetPaymentTermsFail)
  getPaymentTermsFailed(
    ctx: StateContext<PaymentTermStateModel>,
    { error }: PaymentTermActions.GetPaymentTermsFail
  ) {
    ctx.patchState({
      error: error,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  private getTitle() {
    return this.localizationService.translate('payment-terms.title');
  }
}
